import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: 'AIzaSyA2G4l9i4unSG-Bz6zayvj6Z8y9JqPerRE',
  authDomain: 'sonickart-app.firebaseapp.com',
  projectId: 'sonickart-app',
  storageBucket: 'sonickart-app.firebasestorage.app',
  messagingSenderId: '443982695818',
  appId: '1:443982695818:web:b707edc97ad4ac28728c73',
  measurementId: 'G-EF1DG7623K'
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

let analytics = null;
let firebaseAuthReadyPromise = null;

export const ensureFirebaseAuth = async () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (auth.currentUser) {
    return auth.currentUser;
  }

  if (!firebaseAuthReadyPromise) {
    firebaseAuthReadyPromise = signInAnonymously(auth)
      .then((credential) => credential.user)
      .catch((error) => {
        firebaseAuthReadyPromise = null;
        const authCode = error?.code || 'unknown';
        const authMessage = error?.message || 'Anonymous Firebase sign-in failed.';
        const enrichedError = new Error(
          `Firebase anonymous sign-in failed (${authCode}): ${authMessage}. ` +
          'Enable Firebase Authentication -> Sign-in method -> Anonymous for this project.'
        );
        enrichedError.code = authCode;
        console.error('Firebase anonymous sign-in failed:', error);
        throw enrichedError;
      });
  }

  return firebaseAuthReadyPromise;
};

if (typeof window !== 'undefined') {
  firebaseAuthReadyPromise = ensureFirebaseAuth();

  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {
      analytics = null;
    });
}

export { app, analytics, auth, db };
export default app;
